import { PERMANENT_UPPER, PERMANENT_LOWER, PRIMARY_UPPER, PRIMARY_LOWER } from "./dentition";
import { isBridgeFindingCode } from "./chartFindingBehavior";

const BRIDGE_ROWS = [
  { id: "permanent-upper", teeth: PERMANENT_UPPER },
  { id: "permanent-lower", teeth: PERMANENT_LOWER },
  { id: "primary-upper", teeth: PRIMARY_UPPER },
  { id: "primary-lower", teeth: PRIMARY_LOWER },
];

const DEFAULT_BRIDGE_COLOR = "#0d9488";

export function buildBridgeFindingGroups(state, findings = []) {
  const bridgeTeeth = new Map();
  const colorByCode = new Map(findings.map((finding) => [finding.code, finding.color_hex]));
  const teeth = state?.teeth || {};

  for (const [fdi, entry] of Object.entries(teeth)) {
    for (const finding of entry?.findings || []) {
      if (!isBridgeFindingCode(finding.finding_code)) continue;
      const code = finding.finding_code;
      if (!bridgeTeeth.has(code)) bridgeTeeth.set(code, new Set());
      bridgeTeeth.get(code).add(String(fdi));
    }
  }

  const groups = [];
  for (const [code, fdis] of bridgeTeeth.entries()) {
    const color = colorByCode.get(code) || DEFAULT_BRIDGE_COLOR;
    for (const row of BRIDGE_ROWS) {
      let run = [];
      for (const fdi of row.teeth.map(String)) {
        if (fdis.has(fdi)) {
          run.push(fdi);
        } else {
          pushBridgeRun(groups, code, row.id, run, color);
          run = [];
        }
      }
      pushBridgeRun(groups, code, row.id, run, color);
    }
  }

  return groups;
}

function pushBridgeRun(groups, code, rowId, run, color) {
  if (run.length < 2) return;
  groups.push({
    id: `${code}-${rowId}-${run[0]}-${run[run.length - 1]}`,
    kind: "existing_bridge",
    label: "BRIDGE",
    color,
    teeth: run,
    rolesByFdi: {},
  });
}
